<template>
	<div class="amo_form_box">
		<div class="amo_form_title">Оставить заявку</div>
		<div id="amoforms" class="amo_form_container"></div>
	</div>
</template>

<script>
export default {
	name: "AmoFormComponent",
	mounted() {
		if (window.__amo_form_1723938_loaded) return
		window.__amo_form_1723938_loaded = true

		const container = document.getElementById('amoforms')
		if (!container) return

		const paramsScript = document.createElement('script')
		paramsScript.text = '!function(a,m,o,c,r,m){a[o+c]=a[o+c]||{setMeta:function(p){this.params=(this.params||[]).concat([p])}},a[o+r]=a[o+r]||function(f){a[o+r].f=(a[o+r].f||[]).concat([f])},a[o+r]({id:"1723938",hash:"f5618a208e11b1a9c81f20ac6db6ece5",locale:"ru"}),a[o+m]=a[o+m]||function(f,k){a[o+m].f=(a[o+m].f||[]).concat([[f,k]])}}(window,0,"amo_forms_","params","load","loaded");'
		container.appendChild(paramsScript)

		const amoScript = document.createElement('script')
		amoScript.id = 'amoforms_script_1723938'
		amoScript.async = true
		amoScript.charset = 'utf-8'
		amoScript.src = 'https://forms.amocrm.ru/forms/assets/js/amoforms.js?1781859313'
		container.appendChild(amoScript)
	},
}
</script>

<style scoped>
.amo_form_box {
	background-color: #F7F3ED;
	padding: 3em 1em;
	text-align: center;
	width: 100%;
}

.amo_form_title {
	font-size: 1.8em;
	font-weight: 500;
	color: #2C3333;
	margin-bottom: 1em;
}

.amo_form_container {
	max-width: 800px;
	margin: 0 auto;
}

@media (max-width: 567px) {
	.amo_form_box {
		padding: 2em 0.5em;
	}

	.amo_form_title {
		font-size: 1.4em;
	}
}
</style>
